import React, { useState } from 'react';
import './SelectBox.css'; 


const SelectBoxLarge = ({ label, options, defaultValue, onChange, error }) => {
  const [value, setValue] = useState(defaultValue);

  const handleChange = (event) => {
    setValue(event.target.value);
    if (onChange) onChange(event);
  };

  const displayErrors = [error] 

  return (
    <div className='large-select-box-container'>
      <select className='select-box fts-15 common-text ftw-4' value={value} onChange={handleChange} >
        <option value="" disabled hidden className='hidden-select-option fts-6'>  </option>
        {options.map((option, index) => (
          <option className='fts-15 common-text fts-15 ftw-4' key={index} value={option.value}>{option.label}</option>
        ))}
      </select>
      <label className={`select-label  fts-15 common-text ftw-4 ${value ? 'has-value' : ''}`}>{label}</label>
      <div className="select-box-icon">
        <svg width="8" height="6" viewBox="0 0 8 6" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6L0.535899 0L7.4641 0L4 6Z" fill="#424242"/>
        </svg>
      </div>
      {displayErrors.length > 0 && (
        <div className="input-error-message fts-12">
          {displayErrors[0]}
        </div>
      )}
    </div>
  );
};

export default SelectBoxLarge;
